const config = {
  apiKey: 'AIzaSyCjA0vVDMAdmsM6X9IB-E0At8AAyjoi14s',
  authDomain: 'instant-apps.firebaseapp.com',
  databaseURL: 'https://instant-apps.firebaseio.com',
  storageBucket: 'instant-apps.appspot.com',
  messagingSenderId: '130740244675',
  functionsURL: 'https://us-central1-instant-apps.cloudfunctions.net',
  staticURL: 'https://app.whimm.co',
  iaHostName: 'https://whimms.com',
  isProd: true
}

export default config



// WEBPACK FOOTER //
// ./src/config.js